import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    logout: () => void;
    className?: string;
};

export const LogoutLinkComponent = ({ logout, className }: Props) => {
    const { t } = useGranite();

    return (
        <Button
            color={"link"}
            className={cn("tw:p-0", className)}
            onClick={logout}
        >
            {t("logoutLink.link.logout")}
        </Button>
    );
};
